export enum HttpErrors {
  OK = 200,
  CREATED = 201,
  FOUND = 302,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  NOT_ACCEPTABLE = 406
}
